import api from './api';

export interface CurrentUser {
  id: string;
  email: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  givenName?: string;
  familyName?: string;
  created: string;
  updated: string;
  roles?: string[]; // 用户角色数组
  habbyApiUserId?: string; // Habby API 用户 ID，用于文件权限检查
}

class AuthService {
  async getCurrentUser(): Promise<CurrentUser> {
    const response = await api.get<{ success: boolean; data: CurrentUser }>('/me');
    if (!response.data.success) {
      throw new Error('获取用户信息失败');
    }
    return response.data.data;
  }

  async checkAuth(): Promise<boolean> {
    try {
      await this.getCurrentUser();
      return true;
    } catch (error) {
      return false;
    }
  }
}

export default new AuthService();